'use strict';

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

exports.ThemeContext = void 0;

var react_1 = require('react');

var components_1 = require('../../../constants/components');

var theme_1 = __importDefault(require('../../../constants/theme'));

var defaultContextState = {
  themeName: components_1.THEMES.light,
  themeConfig: theme_1.default.light,
};

exports.ThemeContext = react_1.createContext(defaultContextState);
